import Analytics from '@web/services/Analytics/Analytics'

export const ONBOARDING_SCREEN_NAMES: Record<number, string> = {
  1: 'welcome',
  2: 'live_events',
  3: 'club_support',
  4: 'ready'
}

export function onboardingView (screenNumber: number): void {
  Analytics.send({
    action: 'onboarding_view',
    screen_number: String(screenNumber),
    screen_name: ONBOARDING_SCREEN_NAMES[screenNumber] || ''
  })
}

export function onboardingContinueClick (screenNumber: number): void {
  Analytics.send({
    action: 'onboarding_continue_click',
    screen_number: String(screenNumber),
    screen_name: ONBOARDING_SCREEN_NAMES[screenNumber] || ''
  })
}

export function onboardingCardCtaClick (payload: {
  screenNumber: number
  cardName: string
  ctaName: string
}): void {
  Analytics.send({
    action: 'onboarding_card_cta_click',
    screen_number: String(payload.screenNumber),
    card_name: payload.cardName,
    cta_name: payload.ctaName
  })
}

export function onboardingCompleted (): void {
  Analytics.send({
    action: 'onboarding_completed'
  })
}
